<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-users"></i>
          グループ情報
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">グループ</a>
          </li>
      </ul>
    </div>
    <b-tabs v-model="index">
      <b-tab title="サマリー">
        <b-card>
          <!-- <div slot="header">
            <strong>Group Information</strong>
            <small>ユーザー : {{model.count || 0}}</small>
            <span class="float-right">グループ作成時間 : {{model.created_at | datetime}}</span>
          </div> -->
          <b-row class="mb-2">
            <b-col md="9" class="col-form-label">
              サマリー
              <strong class="font_12 text-primary">ユーザー : {{model.count}} </strong>
            </b-col>
            <b-col class="text-right">
              グループ作成時間 : {{model.created_at | datetime}}
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              グループサービスの種類
            </b-col>
            <b-col>
              <b-badge pill  :variant="model.service == 'Basic' ? 'info' : 'success'"> {{model.service}} </b-badge>
            </b-col>
            <b-col md="2" class="col-form-label">
              パートナー
            </b-col>
            <b-col>
              <b-input type="text" v-if="model && model.partner" v-model="model.partner.username" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              グループ名
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.groupname" :plaintext="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              ユーザー
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.count" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
              <b-col md="2" class="col-form-label">
                メールアドレス
                <span class="text-info" v-b-tooltip.hover title="検出および情報伝達メールとして完全なメール通知が必要な場合は、そのメールアドレスに送信されます グループメールの使用をお勧めします。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </b-col>
              <b-col>
                <b-input type="text" v-model="model.email" :disabled="true" :plaintext="lock"></b-input>
              </b-col>
              <b-col md="2" class="col-form-label">
                住所
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.address" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
              <template>
                <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 変更 </b-button>
              </template>
            </template>
            <template v-else>
              <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
              <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
            </template>
        </b-card>
      </b-tab>
      <!-- security policy -->
      <b-tab title="セキュリティポリシー">
        <b-card>
          <b-row>
            <b-col class="title">
              セキュリティポリシー
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              パスワード失敗回数
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              ブロック時間（分）
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              パスワードの最小文字数
            </b-col>
            <b-col class="col-form-label" md="4">
              <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
            </b-col>
            <!-- <b-col md="2" class="col-form-label">
              ブロック時間（分）
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              パスワードにアルファベットを使用
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="パスワードにはアルファベットが必要です、例) abcdef....">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_alphabet" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="2" class="col-form-label">
              パスワードに空白を使用
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="パスワードには特殊文字が必要です。例) !@#$%&*()_+-=">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_number" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              パスワードに数字を使用
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="パスワードには番号が必要です、例) 0123456789">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_spacial" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr>
          <!-- <b-row>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="パスワード失敗回数（デフォルト値）はシステム上5です">
                <label for="ph_lock_count">パスワード失敗回数</label>
                <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="ログインに失敗した場合、デフォルトは5分です">
                <label for="ph_lock_time">ブロック時間（分）</label>
                <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="最小の長さが必要です">
                <label for="ph_password_min_len">パスワードの最小文字数</label>
                <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr> -->
          <!-- <b-row>
            <b-col md="4">
              <b-form-group label="パスワードはアルファベットを使用" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="パスワードにはアルファベットが必要です、例) abcdef....">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_alphabet" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="パスワード特殊文字を使用" label-for="ph_password_use_number" v-b-tooltip.hover title="パスワードには特殊文字が必要です。例) !@#$%&*()_+-=">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_number" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="パスワード番号を使用" label-for="ph_password_use_spacial" v-b-tooltip.hover title="パスワードには番号が必要です、例) 0123456789">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_spacial" :disabled="lock" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr> -->
          <b-row>
            <b-col md="6" class="col-form-label">
              カスタムアカウントのログインセッションのタイムアウト (初期設定値：300秒)
              <h5>5分後にログアウトタイマーがスタートします。</h5>
            </b-col>
            <b-col md="2">
              <div class="input-group">
                <b-input type="number" class="form-control" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                <div class="input-group-append">
                    <button :disabled="true" class="btn btn-sm btn-outline-secondary" type="button">秒</button>
                </div>
              </div>

              <!-- <div class="input-group">
                <input type="text" class="form-control" name="Threshold" id="Threshold" value="300" readonly>
                <div class="input-group-append">
                  <b-btn class="btn btn-outline-secondary">Second</b-btn>
                </div>
              </div> -->
              <!-- <b-input-group size="sm">
                <b-input type="number" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary">Second</b-btn>
                </b-input-group-append>
              </b-input-group> -->
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="12" class="strong text-danger text-center">
              * Allow IP : グループ内の設定は、グループ内のすべてのアカウントに適用されます
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <ip-list
                type="account"
                comment="グループのIPアクセス制御ポリシーが最初に来て、その後にユーザー固有のIPアクセス制御ポリシーが来ます。"
                :lock="lock"
                :press="false"
                :show_button="false"
                :ip_list="model.allow_ip_account || []"
                @add="ip_add"
                @save="save"
                @remove="ip_remove"
                @clear="ip_clear">
              </ip-list>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <!-- <hr> -->
          <b-row class="mb-2">
            <b-col>
              <ip-list
                type="agent"
                comment="IPアクセスコントロールはエージェントインストール時に適用されます。無ければどこにでもインストールできますが、推奨しています。"
                :lock="lock"
                :press="false"
                :show_button="false"
                :ip_list="model.allow_ip_agent || []"
                @add="ip_add"
                @save="save"
                @remove="ip_remove"
                @clear="ip_clear">
              </ip-list>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 変更 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- setting -->
      <b-tab title="設定">
        <b-card>
          <b-row>
            <b-col class="title">
              設定
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              電子メールを許可
            </b-col>
            <b-col md="4">
              <!-- <b-form-group label="" label-for="ph_allow_email" > -->
                <!-- <c-switch color="info" label size="sm" v-model="model.allow_mail" :disabled="lock" /> -->
                <div class="checkbox-switch" v-b-tooltip.hover title="電子メールによるセキュリティ警告を許可します。デフォルトはオンです">
                  <input type="checkbox" class="input-checkbox" v-model="model.allow_mail" :disabled="lock">
                  <div class="checkbox-animate" :class="{ disabled : lock }">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                  </div>
                </div>
              <!-- </b-form-group> -->
            </b-col>
            <b-col class="title" md="2">
              シングルログイン
            </b-col>
            <b-col>
              <!-- <b-form-group label="シングルログイン" label-for="ph_single_login" v-b-tooltip.hover title="許可されるログインは 1 つだけです、デフォルトはオフです">
                <c-switch color="info" label size="sm" v-model="model.single_login" :disabled="lock" />
              </b-form-group> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="許可されるログインは 1 つだけです、デフォルトはオフです">
                <input type="checkbox" class="input-checkbox" v-model="model.single_login" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="title_sub">
                E-mail CC
                <h6>検出関連情報メールを受信するメールアドレスを追加することができます。メールアドレスは1行に1つ作成します。</h6>
              </div>
              <b-form-textarea class="form-control" ref="email_cc_list" :rows="model && model.email_cc && model.email_cc_list ? model.email_cc.length + 2 : 2" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <p>検出関連情報メールを受信するメールアドレスを追加することができます。</p>

              </b-row> -->
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <div class="title_sub">
                Syslog <span class="font_13" style="cursor: pointer;" @click="modal.explain = true">(syslog形式とは何ですか?)</span>

                <button type="button" class="btn btn-sm btn-insert" @click="modal.explain = true">
                  <span class="font_14 text-info">
                    <span>
                      <i class="fas fa-question-circle"></i>
                    </span>
                </span>
                </button>
                <h6>生成されたログをリモートで送信することができます。主にコントロールセンターとの接続に使用します。1行に1つのIP（例）1.1.1.1:514)を記述します。</h6>
              </div>
              <b-form-textarea class="form-control" ref="syslog_list" :rows="model && model.syslog && model.syslog_list ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <p>検出関連情報メールを受信するメールアドレスを追加することができます。</p>

              </b-row> -->
            </b-col>
            <!-- <b-col md="12">
              <b-form-group>
                <label for="ph_syslog" v-b-tooltip.hover title="syslog サーバーの IP を入力します。例: 192.168.0.100、192.168.0.100:511">
                  <h4>
                    Syslog <small style="cursor: pointer;" @click="modal.explain = true">(what is syslog format ?)</small>
                  </h4>
                  <span>生成されたログをリモートで送信することができます。主にコントロールセンターとの接続に使用します。</span>
                </label>
                <hr>
                <b-form-textarea style="background-color:#f0f3f5;" ref="syslog_list" :rows="model && model.syslog && model.syslog_list ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              </b-form-group>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
            <!-- 通知の種類 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle Mode
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">ブロック</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_block" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub">検出</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_detect" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col>
              <b-form-group label="">
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_block" >ブロック</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_detect" >検出</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="8">
              <b-form-group label="WEBCastleの重大度">
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_emergency" >緊急</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_alert" >アラート</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_critical" >致命的</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_error" >エラー</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_warning" >警告</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_info" >情報</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
          </b-row>
          <b-row>
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
            <!-- 通知の種類 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle Severity
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub">緊急</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_emergency" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">アラート</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_alert" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-2">致命的</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_critical" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">エラー</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_error" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-1">警告</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_warning" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">通知</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_info" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col md="8">
              <b-form-group label="WEBCastleの重大度">
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_emergency" >Emergency</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_alert" >Alert</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_critical" >Critical</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_error" >Error</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_warning" >Warning</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_info" >Info</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 変更 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- メンバーシップ(購読情報)の解約 -->
      <b-tab title="メンバーシップ"
        v-if="auth && auth.profile && auth.profile.permissions && auth.profile.permissions.toUpperCase() == 'OWNER' && auth.license && !auth.license.onPremise"
        @click="signout_status"
      >
        <b-row>
          <b-col md="12">
            <h4>
              <center>サブスクリプションの状況 :
                <b-badge  :variant="status.all_bill_pay && status.processing ? (status.approve ? 'danger' : 'warning') : 'success'">
                  <!-- {{status.all_bill_pay && status.processing ? (status.approve ? 'End of service' : 'Stoped') : 'Using'}} -->
                  {{status.all_bill_pay && status.processing ? (status.approve ? 'サービス終了' : '停止') : '使用中'}}
                </b-badge>
              </center>
            </h4>
          </b-col>
        </b-row>
        <hr>
        <div>
          <b-jumbotron>
            <!-- <b-button class="text-left" :disabled="status.all_bill_pay" variant="success" href="#" @click="request_billing">
              <del v-if="status.all_bill_pay">STEP.1 今月の請求のリクエスト</del>
              <span v-else>STEP.1 今月の請求のリクエスト</span>
            </b-button> -->
            <!-- <span v-if="status.all_bill_pay">✔️ クリア</span>
            <br>
            <br> -->
            <!-- move to billing -->
            <!-- <h4 class="lead">* 未払金がないことを確認</h4>
            <h4 class="lead">* <a href="#" @click="$router.push({ name : 'billing' })">請求</a>へ</h4> -->
            <!-- <hr> -->
            <b-button class="text-left" variant="warning" :disabled="status.all_bill_pay && status.processing" href="#" @click="signout_stop">
              <del v-if="status.all_bill_pay && status.processing">STEP1. 停止依頼と今月の請求</del>
              <span v-else>STEP.1 利用停止を申し出て、今月の請求額を確認する</span>
            </b-button>
            <span v-if="status.all_bill_pay && status.processing">✔️ クリア</span>
            <br>
            <br>
            <!-- 停止要求してもサービスは利用可能 / 設定変更を阻止すべきかどうか確認必要 -->
            <h4 class="lead">* エージェントの設定は承認されるまで保持され、承認後は復元できません。</h4>
            <h4 class="lead">* 停止を申し込むと、課金されなくなります。</h4>
            <h4 class="lead">* <a href="#" @click="signout_cancel">"サービス停止・退会申請について"</a>キャンセルする</h4>
            <hr>
            <b-button :disabled="status.approve" class="text-left" variant="danger" @click="notice">STEP.2 審査後問題がなければ、通常のキャンセルとリマインダーが送られます。その後の復旧はできません。</b-button>
            <br>
            <br>
            <h4 class="lead">* 使用中のサービスは停止しています</h4>
            <h4 class="lead">* 承認結果の案内をメールで受け取ることができます </h4>
            <h4 class="lead">* エージェントの設定は承認されるまで保持され、承認後は復元できません</h4>
          </b-jumbotron>
          <hr>
        </div>
      </b-tab>
      <!-- 行動ログ -->
      <b-tab title="アクションログ">
        <actionList v-if="model.id" :group_id="model.id" />
      </b-tab>
    </b-tabs>
    <b-modal :title="modal.title"  class="modal-warning" v-model="modal.confirm" @ok="remove" ok-variant="warning">
     {{modal.msg || '本当にこれを適用しますか？'}}
    </b-modal>
    <b-modal size="xl" title="Syslog形式の説明"  class="modal-info" v-model="modal.explain" ok-variant="success" ok-only hide-footer>
      <h4>Rsyslog形式</h4>
      <b-table class="table_add table-striped" hover :items="log_format" :fields="['Fields', 'Value']"></b-table>
      <h4 class="title">メッセージ詳細フォーマット</h4>
      <hr>
      <h4 class="title_sub">
        WebCastle
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|[PublicIP]|[SourceIP]|[ServerName]|Group:[groupname]|Direction:[SourceIP:SourcePORT]->[DestinationIP:DestinationPORT]|Risk:[risk]|Message:[PolicyName]|Host:[header's Host]|URI:URI Information]|Action:[block|detect]|Policy:[PolicyID]:[PolicyDetailInformation]
      </pre>
      <p class="col-form-label">サンプル検出またはブロック</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:35.84.178.246:58030->t1.com:80|Risk:Alert|Message:Host header is a numeric IP address|Host:158.247.215.235|URI:/.noindex.html|Action:block|Policy:[920350]Matched \"Operator `Rx' with parameter `^[\\d.:]+$' against variable `REQUEST_HEADERS:Host' (Value: `158.247.215.235' )"
      </pre>
      <p class="col-form-label">リソースアラートまたはWAFエンジンダウンのサンプル</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:-|Risk:Critical|Message:WAF was down|Host:vultr.guest1|URI:-|Action:-|Policy:-
      </pre>

      <h4 class="title_sub">
        WSFinder
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|[SourceIP]|[DestinationIP]|[ServerName]|Group:[groupname]|Direction:-|Risk:danger|Message:[forgery|detect]|Host:[ServerName]|URI:-]|Action:[Isolation|detect|forgery]|Policy:[PolicyInformation]
      </pre>
      <p class="col-form-label">サンプル検出または偽造</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|/var/www/html/webshell/php/itsec.php|dev_04|dev_04@172.17.0.12|Group:hdh_dev_01|Direction:-|Risk:danger|Message:Regex detected|Host:dev_04|URI:-|Action:detection|Policy:11

        WSFinder|1|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:[1]:/var/www
      </pre>
      <p class="col-form-label">リソースアラートのサンプル</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %
      </pre>

      <h4 class="title_sub">
        WMDS
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WMDS|[Specific URL]|[wmds.agent]|[Site Name]|Group:[groupname]|Direction:-|Risk:[Risk]|Message:[Detection classification]|Host:[FQDN|URL]|URI:-]|Action:[detect|forgery]|Policy:[Evidence for detection]
      </pre>
      <p class="col-form-label">サンプル検出または偽造</p>
      <pre class="form-control" style="font-size: 14px !important;">
        <!-- detect -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:malware detected|Host:dev_06|URI:-|Action:detect|Policy:f1security_policy_scan_daily
        <!-- forgery -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:/var/www
      </pre>

      <!-- <b-table hover :items="log_format_case" :fields="['Type', 'Attacker', 'Victim(Target)', 'Name',  'Action']"></b-table> -->
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="modal.explain = false">閉じる</button>
      </div>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>

<!-- Direction:{reportData.client_ip}:{reportData.client_port}->{reportData.host_ip}:{reportData.host_port}|Risk:{min_risk}|Message:{reportData.messages.message}|Host:{log.host}|URI:{log.uri}|Action:{((bool)log?.is_block ? "block" : "detection")}|Policy:[{reportData.messages.details.ruleId}]{reportData.messages.details.match.ToString()}" -->
